export default __webpack_public_path__ + "static/media/building2.ce02cf40.png";